import { render, staticRenderFns } from "./ModalBankingServicesPayments.vue?vue&type=template&id=52342140&scoped=true"
import script from "./ModalBankingServicesPayments.vue?vue&type=script&lang=js"
export * from "./ModalBankingServicesPayments.vue?vue&type=script&lang=js"
import style0 from "./ModalBankingServicesPayments.vue?vue&type=style&index=0&id=52342140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52342140",
  null
  
)

export default component.exports